import styled from '@emotion/styled'
import { WithClassName } from '~/types/utils'
import { Icon, IconProps } from './Icon'
import { Tooltip, TooltipProps } from './Tooltip'

const VerticalAlignedTooltip = styled(Tooltip)`
  display: inline-flex;
  align-items: center;
`

type IconWithTooltipProps = WithClassName & IconProps & Pick<TooltipProps, 'title' | 'align'>
const BaseIconWithTooltip = ({ title, align, ...iconProps }: IconWithTooltipProps) => {
  return (
    <VerticalAlignedTooltip align={align} title={title}>
      <Icon {...iconProps} />
    </VerticalAlignedTooltip>
  )
}

export const IconWithTooltip = styled(BaseIconWithTooltip)``
